import { intersection } from 'lodash-es';
export const needLoadSqlService = (supportLanguages) => {
    return intersection(supportLanguages || [], ['sql-blink', 'sql-flink', 'sql-odps']).length > 0;
};
